export const selectLocationInfo = (state) => state.forms.locationInfo;
export const selectVehicleInfo = (state) => state.forms.vehicleInfo;
export const selectTransactionInfo = (state) => state.forms.transactionInfo;
export const selectFirstBuyerInfo = (state) => state.forms.firstBuyerInfo;
export const selectSecondBuyerInfo = (state) => state.forms.secondBuyerInfo;
export const selectFirstSellerInfo = (state) => state.forms.firstSellerInfo;
export const selectSecondSellerInfo = (state) => state.forms.secondSellerInfo;
export const selectInsuranceInfo = (state) => state.forms.insuranceInfo;
export const selectLienHolderInfo = (state) => state.forms.lienHolderInfo;
export const selectFirstOwnerInfo = (state) => state.forms.firstOwnerInfo;
export const selectSecondOwnerInfo = (state) => state.forms.secondOwnerInfo;
export const selectSelectedCards = (state) => state.forms.selectedCards;
